(function ($, window) {
    /**
     * Create empty global functions for internal usage
     * @since 1.0
     */
    if ('undefined' === typeof window.TL)
        window.TL = {};

    /**
     * Set app data to use foe whole site
     * @since 2019-03-05
     * 
     * @update 2019-05-30
     * @desc Also create empty ui object at once
     */
    var LOCAL_DATA = window.localData;

    
    var changeTimeZone = function (date, timeZone) {
        
         if (typeof date === 'undefined') {             
             return date;
        }
                
        if (typeof date === 'string') {
          return new Date(
            new Date(date).toLocaleString('en-US', {
              timeZone,
            }),
          );
        }
        
        return new Date(
          date.toLocaleString('en-US', {
            timeZone,
          }),
        );
    }
    
    
    /**
     * Parse a date value without shifting it by the browser time zone.
     * Date-only strings (yyyy-MM-dd, as rendered by the server in property
     * time zone) must be treated as local calendar dates, because
     * new Date('yyyy-MM-dd') is parsed as UTC midnight and shows the previous
     * day in browsers west of UTC.
     */
    var parseDate = function (val) {
        if (typeof val === 'string') {
            var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(val.trim());
            if (m) {
                return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
            }
        }
        return new Date(val);
    };

    /**
     * Today's calendar date (local midnight) in the property time zone.
     */
    var getPropertyToday = function () {
        var now = LOCAL_DATA && LOCAL_DATA.h_timezone
            ? changeTimeZone(new Date(), LOCAL_DATA.h_timezone)
            : new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    };

    $.extend(true, window.TL, {
        app: {
            path: location.origin + '/propertyibe2',
            language: null,
            currency: null,
            calendar: {
                checkin: getPropertyToday(),
                checkout: (function () { var d = getPropertyToday(); d.setDate(d.getDate() + 1); return d; })(),
                disabledDate: [
                    '2020-05-21',
                    '2020-05-23',
                    '2020-05-24',
                    '2020-06-15',
                    '2020-06-16'
                ],
                set: function(param, value) {
                    this[param] = value
                },
                get: function(param) {
                    return this[param]
                }
            },
            reservation: {
                propertyId: '',
                s_checkin: LOCAL_DATA.h_checkin,
                s_checkout: LOCAL_DATA.h_checkout,
                s_numofroom: LOCAL_DATA.h_numofroom,
                s_numofadult: LOCAL_DATA.h_numofadult,
                s_numofchild: LOCAL_DATA.h_numofchild,
                s_accesscode: initAccessCode(),
                set: function (param, value) {
                    this[param] = value
                },
                get: function (param) {
                    return this[param]
                }
            },
            changeTimeZone: changeTimeZone,
            parseDate: parseDate,
            getPropertyToday: getPropertyToday,
        },
        ui: {},
        i18n: {},
        contact_form:{}
    });

    if (undefined === window.TL.ui.localeYear) {
        window.TL.ui.localeYear = function( standard_year ) {
            var year = parseInt(standard_year)
            var language_codes = ['th']
            if ( language_codes.includes(localData.h_lang) ) {
                year = year + 543
            }
            return year
        }
    }
    
    function toDate(val) {
        var parts = val.split('-');
        return new Date(parts[0], parts[1] - 1, parts[2]);
    }
    
    function initDate(el) {
        var DATE_FORMAT = 'YYYY-MM-DD';
        var defaultValue;
        
        if (el === 'selectedCheckInDate') {
            defaultValue = moment(getPropertyToday()).format(DATE_FORMAT);
        } else if (el === 'selectedCheckOutDate') {
            defaultValue = moment(getPropertyToday()).add(2, 'day').format(DATE_FORMAT);
        } else {
            throw new Error('Not support, possible values are selectedCheckInDate or selectedCheckOutDate');
        }
        
        return initValueWithDefault(el, defaultValue);
    }
    
    function initAdult() {
        return initValueWithDefault('selectedNumberOfAdults', 2);
    }
    
    function initChild() {
        return initValueWithDefault('selectedNumberOfChildren', 0);
    }
    
    function initRoom() {
        return initValueWithDefault('selectedNumberOfRooms', 1);
    }
    
    function initAccessCode() {
        return initValueWithDefault('productAccessCodeInput', '');
    }
    
    function getElementValue(el) {
        return document.getElementById(el).value;
    }
    
    function initValueWithDefault(el, defaultValue) {
        try {
            return getElementValue(el);
        } catch(e) {
            return defaultValue;
        } 
    }
    
})(jQuery, window);